<template>
  <v-app>


  HEALTH DASHBOARD

<v-card class="ma-4 pa-4" outlined>
  <v-card-title>Schlaf Verlauf</v-card-title>

  <v-card-text v-if="healthEntries?.length">
    <div>
      <HealthSleepChart :items="healthEntries ?? []" />
    </div>
  </v-card-text>
</v-card>


<v-card class="ma-4 pa-4" outlined>
  <v-card-title>Herzfrequenz Verlauf</v-card-title>

  <v-card-text v-if="healthEntries?.length">
    <div >
      <HealthHeartRateChart :items="healthEntries ?? []" />
    </div>
  </v-card-text>
</v-card>


  <v-card class="ma-4 pa-4" >
    <v-card-title>Gewichtswerte</v-card-title>

    <v-card-text v-if="healthEntries?.length">
      <div >
        <HealthLineChart :items="healthEntries" />
      </div>
    </v-card-text>

    <v-card-text>

    </v-card-text>
  </v-card>


<v-card class="ma-4 pa-4" outlined>
  <v-card-title>LLM Summary Download</v-card-title>

  <v-card-text>
    <v-row>
      <v-col cols="12" sm="4">
        <v-text-field
          label="Von"
          type="date"
          v-model="llmFromDate"
          dense
        />
      </v-col>

      <v-col cols="12" sm="4">
        <v-text-field
          label="Bis"
          type="date"
          v-model="llmToDate"
          dense
        />
      </v-col>

      <v-col cols="12" sm="4" class="d-flex align-center">
        <v-btn
          color="primary"
          :loading="llmDownloadLoading"
          @click="downloadLlmSummaries()"
        >
          Download (JSON)
        </v-btn>
      </v-col>
    </v-row>

    <div class="text-caption" style="opacity:0.8;">
      Default: letzte 120 Tage
    </div>
  </v-card-text>
</v-card>




  <v-card class="ma-4 pa-4" outlined>
  <v-card-title>Werte aus der FAST API DB</v-card-title>

  <v-card-text>
    <v-data-table
      :headers="healthHeaders"
      :items="healthEntries ?? []"
      :items-per-page="25"
      dense
      class="elevation-1"
    >
         <template #headers>
            <tr>
              <th
                v-for="h in healthHeaders"
                :key="h.value"
                class="text-left"
                style="color:#ddd;font-weight:600;"
              >
                {{ h.text }}
              </th>
            </tr>
          </template>

<template v-slot:item.deep_sleep_seconds="{ item }">
  <span v-if="item.deep_sleep_seconds">
    {{ (item.deep_sleep_seconds / 3600).toFixed(2) }} h
  </span>
  <span v-else>–</span>
</template>

<template v-slot:item.average_stress_level="{ item }">
  <v-chip
    v-if="item.average_stress_level !== null"
    :color="item.average_stress_level < 25 ? 'green'
          : item.average_stress_level < 35 ? 'orange'
          : 'red'"
    dark
    small
  >
    {{ item.average_stress_level }}
  </v-chip>
  <span v-else>–</span>
</template>

<template v-slot:item.body_battery_during_sleep="{ item }">
  <span v-if="item.body_battery_during_sleep !== null">
    {{ item.body_battery_during_sleep }}
  </span>
  <span v-else>–</span>
</template>

<template v-slot:item.avg_waking_respiration_value="{ item }">
  <span v-if="item.avg_waking_respiration_value">
    {{ item.avg_waking_respiration_value }} /min
  </span>
  <span v-else>–</span>
</template>


      <template v-slot:item.calendar_date="{ item }">
        {{ item.calendar_date }}
      </template>

      <template v-slot:item.weight="{ item }">
        <!-- if your DB weight is stored in grams like Garmin: -->
        <span v-if="item.weight != null">{{ (item.weight / 1000).toFixed(1) }} kg</span>
        <span v-else>-</span>
      </template>

      <template v-slot:item.bmi="{ item }">
        <span v-if="item.bmi != null">{{ Number(item.bmi).toFixed(1) }}</span>
        <span v-else>-</span>
      </template>

      <template v-slot:item.body_water="{ item }">
        <span v-if="item.body_water != null">{{ Number(item.body_water).toFixed(1) }} %</span>
        <span v-else>-</span>
      </template>

    <template v-slot:item.sleep_time_seconds="{ item }">
      <span v-if="item.sleep_time_seconds != null">{{ (item.sleep_time_seconds / 3600).toFixed(2) }} h</span>
      <span v-else>-</span>
    </template>


    <template v-slot:item.light_sleep_seconds="{ item }">
      <span v-if="item.light_sleep_seconds != null">{{ (item.light_sleep_seconds / 3600).toFixed(2) }} h</span>
      <span v-else>-</span>
    </template>

    <template v-slot:item.rem_sleep_seconds="{ item }">
      <span v-if="item.rem_sleep_seconds != null">{{ (item.rem_sleep_seconds / 3600).toFixed(2) }} h</span>
      <span v-else>-</span>
    </template>

    <template v-slot:item.awake_sleep_seconds="{ item }">
      <span v-if="item.awake_sleep_seconds != null">{{ (item.awake_sleep_seconds / 3600).toFixed(2) }} h</span>
      <span v-else>-</span>
    </template>


      <template v-slot:no-data>
        Keine Health-Daten in der DB vorhanden
      </template>
    </v-data-table>
  </v-card-text>
</v-card>




<v-card class="ma-4 pa-4" outlined>
  <v-card-title>
    Gesundheitswerte ({{ dailyWeighIns[0]?.calendarDate }})
  </v-card-title>

  <v-card-text v-if="dailyWeighIns.length">
    <v-row>
      <v-col cols="12" sm="4">
        <strong>Gewicht</strong><br />
        {{ (dailyWeighIns[0].weight / 1000).toFixed(1) }} kg
      </v-col>

      <v-col cols="12" sm="4">
        <strong>BMI</strong><br />
        {{ dailyWeighIns[0].bmi.toFixed(1) }}
      </v-col>

      <v-col cols="12" sm="4">
        <strong>Körperwasser</strong><br />
        {{ dailyWeighIns[0].bodyWater.toFixed(1) }} %
      </v-col>
    </v-row>
  </v-card-text>

  <v-card-text v-else>
    Keine Daten vorhanden
  </v-card-text>
</v-card>


  <v-card
    class="mx-auto"
    prepend-icon="$vuetify"
    subtitle="Datenmodell aufbauen + Neuen Ablauf 1 mal am Tag oder anpassen"
    width="400"
  >
    <template v-slot:title>
      <span class="font-weight-black">Werte aus der FAST API DB</span>
    </template>

    <v-card-text class="bg-surface-light pt-4">
      Gewicht:
    </v-card-text>
  </v-card>

    <v-card
    class="mx-auto"
    prepend-icon="$vuetify"
    subtitle="The #1 Vue UI Library"
    width="400"
  >
    <template v-slot:title>
      <span class="font-weight-black">Werte online aus Garmin</span>
    </template>

    <v-card-text v-if="dailyWeighIns.length" class="bg-surface-light pt-4">
    Aber diese gerade nicht, die will ich ja speichern...

    <v-row>
      <v-col cols="12" sm="4">
        <strong>Gewicht</strong><br />
        {{ (dailyWeighIns[0].weight / 1000).toFixed(1) }} kg
      </v-col>

      <v-col cols="12" sm="4">
        <strong>BMI</strong><br />
        {{ dailyWeighIns[0].bmi.toFixed(1) }}
      </v-col>

      <v-col cols="12" sm="4">
        <strong>Körperwasser</strong><br />
        {{ dailyWeighIns[0].bodyWater.toFixed(1) }} %
      </v-col>
    </v-row>
  </v-card-text>

  <v-card-text v-else>
    Keine Daten vorhanden
  </v-card-text>


  </v-card>



  </v-app>
</template>


<script>
import HealthLineChart from "@/components/HealthLineChart.vue";
import HealthHeartRateChart from "@/components/HealthHeartRateChart.vue";
import HealthSleepChart from "@/components/HealthSleepChart.vue";
import { mapGetters, mapActions } from 'vuex';
import axios from '@/api/client';

export default {
  name: 'HealthDashboardScreen',
    components: {
    HealthLineChart,
    HealthHeartRateChart,
    HealthSleepChart,
    },

    data: () => ({
      dailyWeighIns: [
            {
                "samplePk": 1766125672430,
                "date": 1766129243000,
                "calendarDate": "2025-12-19",
                "weight": 77120.0,
                "bmi": 23.299999237060547,
                "bodyFat": 24.0,
                "bodyWater": 55.5,
                "boneMass": 3880,
                "muscleMass": 30629,
                "physiqueRating": null,
                "visceralFat": null,
                "metabolicAge": null,
                "sourceType": "INDEX_SCALE",
                "timestampGMT": 1766125643000,
                "weightDelta": 99.99999999999432
            }
        ],
      llmFromDate: null,
      llmToDate: null,
      llmDownloadLoading: false,
      item: '',
      passwort: '',
      user: '',
      ShowUserError: true,
      dialog: false,
      dialogDelete: false,
      editedIndex: -1,
      editedItem: {
        idSettings: 0,
        settings_key: '',
        settings_value: '',
      },
      items_pagenumber: ['10', '20', '50', '100'],
      items_paths: ['/vue', '/analyzer','/activities','/articles','/calendar','/charts', '/dashboard','/historie','/stocks','/rankings','/tracklist','/chat','/trainObjects','/users'],
      options2: {},
      array_allSettings: [],
       healthHeaders: [
          { text: "Datum", value: "calendar_date" },
          { text: "Gewicht", value: "weight" },
          { text: "BMI", value: "bmi" },
          { text: "Body Fat", value: "body_fat" },
          { text: "Body Water", value: "body_water" },
          { text: "HR Resting", value: "hr_resting" },
          { text: "HR Min", value: "hr_min" },
          { text: "HR Max", value: "hr_max" },

          // Neu wichtige Gesudheitsattribute
          { text: 'Tiefschlaf (h)', value: 'deep_sleep_seconds' },
          { text: 'Stress', value: 'average_stress_level' },
          { text: 'Body Battery Schlaf', value: 'body_battery_during_sleep' },
          { text: 'Atemfrequenz', value: 'avg_waking_respiration_value' },

            // ---- Sleep (NEU) ----
          { text: "Sleep Score", value: "sleep_score" },
          { text: "Total Sleep", value: "sleep_time_seconds" },
          { text: "Deep", value: "deep_sleep_seconds" },
          { text: "Light", value: "light_sleep_seconds" },
          { text: "REM", value: "rem_sleep_seconds" },
          { text: "Awake", value: "awake_sleep_seconds" },
          { text: "Avg Sleep HR", value: "avg_sleep_hr" },
          { text: "Avg Sleep Stress", value: "avg_sleep_stress" },
       ],
      pagination: {
        rowsPerPage: -1
      },

    }),
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    computed: {
        ...mapGetters({
          settings: "stateSettings",
          healthEntries: "stateHealthEntries",
          healthEntry: "stateHealthEntry",
        }),
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }
    },
    async mounted() {
        console.log("HealthDashboard mounted");

        // ✅ load DB health table data
        await this.getHealthEntries();
        // Default: letzte 120 Tage
        const to = new Date();
        const from = new Date();
        from.setDate(to.getDate() - 120);

        const toIso = to.toISOString().slice(0, 10);
        const fromIso = from.toISOString().slice(0, 10);

        this.llmFromDate = fromIso;
        this.llmToDate = toIso;



      //tut aber auskommentiert damit nicht dauernd api aufrufen und erstmal in die DB
      //const response = await this.getOnlineHealthdata();
      //this.dailyWeighIns = response.data.output.dateWeightList





    },

    created: function () {
      console.log('healtdashboard created')



    },

methods: {
    ...mapActions([
      "updateSetting",
      "getHealthEntries",
      "viewHealthEntry",
      "getHealthRange",
      "downloadLlmSummaryRange",
    ]),
async downloadLlmSummaries() {
  if (!this.llmFromDate || !this.llmToDate) return;

  this.llmDownloadLoading = true;
  try {
    await this.downloadLlmSummaryRange({
      fromDate: this.llmFromDate,
      toDate: this.llmToDate,
    });
  } catch (e) {
    console.error("LLM Summary Download failed", e);
  } finally {
    this.llmDownloadLoading = false;
  }
},
async getOnlineHealthdata() {
  try {
    const resp = await axios.get('/garmin/get_daily_weigh_ins');

    // ✅ hier die Nutzdaten holen (dein Beispiel: output.dateWeightList[0])
    this.dailyWeighIns = resp?.data?.output?.dateWeightList?.[0] ?? null;

    return resp; // optional, falls du es in mounted() weiter benutzen willst
  } catch (err) {
    console.error('Fehler beim Laden', err);
    this.dailyWeighIns = null;
    return null;
  } finally {
    this.devicesLoading = false;
  }
},


  }
}
</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


